import type { PodTaskSourceType } from "@app/types/project_task";
import {
  BookOpen01,
  CalendarCheck01,
  ConfluenceLogo,
  DriveLogo,
  GithubLogo,
  GmailLogo,
  MessageChatSquare,
  MicrosoftLogo,
  NotionLogo,
  RefreshCw01,
  SlackLogo,
  User01,
} from "@dust-tt/sparkle";
import type { ComponentType } from "react";

/**
 * One icon per source type, in one place: three surfaces render task sources
 * and every source type added since has had to be added to all three.
 */
export const podTaskSourceIcons: Record<
  PodTaskSourceType,
  ComponentType<{ className?: string }>
> = {
  conversation: MessageChatSquare,
  project_conversation: MessageChatSquare,
  project_knowledge: BookOpen01,
  slack: SlackLogo,
  notion: NotionLogo,
  gdrive: DriveLogo,
  confluence: ConfluenceLogo,
  github: GithubLogo,
  microsoft: MicrosoftLogo,
  gmail: GmailLogo,
  granola: CalendarCheck01,
  hubspot: MessageChatSquare,
  calendar: CalendarCheck01,
  wiki_person: User01,
  wiki_project: BookOpen01,
  routine_template: RefreshCw01,
};
